import * as Sentry from '@sentry/vue';
import { browserTracingIntegration } from '@sentry/vue';
import { App } from 'vue';
import router from '../router';

function sentry(app: App) {
   // temporaraly enable Sentry for all environments
   const enabled = true;
   // const enabled = ['acc', 'prod', 'release'].includes(import.meta.env.VITE_APP_ENV);
   const browserTracing = browserTracingIntegration({ router });

   Sentry.init({
      app,
      attachProps: true,
      attachStacktrace: true,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      enabled,
      environment: import.meta.env.VITE_APP_ENV,
      integrations: [browserTracing],
      logErrors: true,
      maxBreadcrumbs: 50,
      release: import.meta.env.VITE_APP_VERSION,
      tracesSampleRate: 0.1,
      trackComponents: true,
   });
}

export default sentry;
